import { Icon } from '@/src/components/ui';
import { cn } from '@workspace/ui/lib/utils';

export const StarRating = ({
  rating,
  className,
}: {
  rating: number | null;
  className?: string;
}) => {
  if (rating === null) {
    return <button className="text-sm">All reviews</button>;
  }
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <Icon
          key={star}
          name="star"
          className={cn(
            'size-3',
            {
              'text-black': star <= rating,
              'text-gray-300': star > rating,
              'text-black/40': className && star <= rating,
            },
            className
          )}
        />
      ))}
    </div>
  );
};